module.exports = __webpack_public_path__ + "img/vr2_detail.f3ea38a9.jpg";